import { render, staticRenderFns } from "./ZoneDetails.vue?vue&type=template&id=b4912354&scoped=true"
import script from "./ZoneDetails.vue?vue&type=script&lang=js"
export * from "./ZoneDetails.vue?vue&type=script&lang=js"
import style0 from "./ZoneDetails.vue?vue&type=style&index=0&id=b4912354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4912354",
  null
  
)

export default component.exports